import { render, staticRenderFns } from "./permanent_residence_card.vue?vue&type=template&id=38ccb710&"
import script from "./permanent_residence_card.vue?vue&type=script&lang=js&"
export * from "./permanent_residence_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports